import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  useDisclosure,
  Link,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../components/CustomButton";
import { ComunitariaModal } from "../Comunitaria/ComunitariaModal";
import { GuardaModal } from "../Guarda/GuardaModal";
import { IrmaoTable } from "../Irmaos/Table/index";
import React, { useEffect, useState, useCallback } from "react";
import {
  Permission,
  criancaFunc,
  referenciaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import SemRegistros from "../../../../components/SemRegistros";
import { useLocation, useParams } from "react-router";
import CriancaService from "../../../../../main/services/CriancaService";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import Swal from "sweetalert2";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { cpf, normalizeString } from "../../../../utils/masks";
import { IrmaosCadastrar } from "../Irmaos/Cadastrar";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { IconeDownload } from "../../../../components/IconeDownload";
import { useHistory } from "react-router-dom";
import { intervalToDuration } from "date-fns";
import { generateAddressFiliacao } from "../../../../utils/generateAddressFiliacao";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";
import { deleteUrlParam } from "../../../../utils/deleteUrlParam";

export const VisualizarReferenciaFamiliar = ({ setLoadingPainel }) => {
  const {
    isOpen: isOpenCadastrar,
    onOpen: onOpenCadastrar,
    onClose: onCloseCadastrar,
  } = useDisclosure();
  const {
    isOpen: isOpenCadastrarReferencia,
    onOpen: onOpenCadastrarReferencia,
    onClose: onCloseCadastrarReferencia,
  } = useDisclosure();
  const {
    isOpen: isOpenCadastrarGuarda,
    onOpen: onOpenCadastrarGuarda,
    onClose: onCloseCadastrarGuarda,
  } = useDisclosure();

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();

  const { id } = useParams();

  const [data, setData] = useState([]);
  const [dataGuarda, setDataGuarda] = useState([]);
  const [dataIrmaos, setDataIrmaos] = useState([]);
  const [cpfBlocked, setCpfBlocked] = useState(false);
  const [loadingReferencia, setLoadingReferencia] = useState(false);
  const [loadingIrmaos, setLoadingIrmaos] = useState(false);
  const [, setLoadingGuarda] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const [maiorIdade, setMaiorIdade] = useState(false);
  const { filiacao, idPJ } = useAppContext();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia]
  );

  const [isButtonDisabledSemFalecido, setIsButtonDisabledSemFalecido] =
    useState(true);
  const [isButtonDisabledFiliacao, setIsButtonDisabledFiliacao] =
    useState(true);

  const updateButtonStateSemFalecido = useCallback(() => {
    const temFiliacaoSemFalecido = filiacao.every(
      (item) =>
        item.id === null ||
        normalizeString(item.filiacao.nome) ===
          normalizeString("Sem Informação")
    );
    setIsButtonDisabledSemFalecido(temFiliacaoSemFalecido);
  }, [filiacao]);

  const updateButtonStateFiliacao = useCallback(() => {
    const temFiliacao = filiacao.every(
      (item) =>
        item.id === null ||
        normalizeString(item.filiacao.nome) ===
          normalizeString("Sem Informação") ||
        item.filiacao.falecido === "S"
    );
    setIsButtonDisabledFiliacao(temFiliacao);
  }, [filiacao]);

  useEffect(() => {
    updateButtonStateSemFalecido();
  }, [filiacao, updateButtonStateSemFalecido]);

  useEffect(() => {
    updateButtonStateFiliacao();
  }, [filiacao, updateButtonStateFiliacao]);

  const riscoAlert = (id, idPJCrianca, riscoVida, idMovimento) => {
    if (
      riscoVida === "S" &&
      roleKeycloack &&
      idMovimento !== 2 &&
      roleKeycloack.length > 0 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  const getDownloadGuarda = (idCrianca) => {
    CriancaService.getAnexoGuardaReferenciaFamiliar(idCrianca)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      Header: "Nome do Irmão",
      accessor: "pessoaFisicaIrmao",
      Cell: (props) => {
        const nome = props?.value?.nome;

        const id = props?.row?.original?.idCrianca;
        const situacao = props?.row?.original?.situacao;

        if (situacao !== "Sem histórico de acolhimento") {
          return (
            <Link
              whiteSpace={{ base: "nowrap", lg: "normal" }}
              wordBreak={nome?.length > 45 && "break-all"}
              title={nome}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.idPessoaJuridica,
                  props?.row?.original?.riscoVida,
                  props?.row?.original?.movimentacoes[0]?.idMovimento
                )
              }
            >
              <Text title={nome}>{nome}</Text>
            </Link>
          );
        } else {
          return (
            <Text
              whiteSpace={{ base: "nowrap", lg: "normal" }}
              wordBreak={nome?.length > 45 && "break-all"}
              title={nome}
            >
              {nome}
            </Text>
          );
        }
      },
    },

    {
      Header: "Filiação em Comum",
      accessor: "filiacoes",
      Cell: (props) => {
        const filiacoes = props.value
          .sort((a, b) => a.tipoFiliacao?.localeCompare(b.tipoFiliacao))
          .map((item, index) => (
            <React.Fragment key={index}>
              {item.nome}
              <Text as="span" textTransform="capitalize">
                {item?.tipoFiliacao
                  ? ` (${item?.tipoFiliacao?.toLowerCase()})`
                  : ""}
              </Text>
              {index < props.value.length - 1 && <hr />}
            </React.Fragment>
          ));

        return <Text whiteSpace={"nowrap"}>{filiacoes}</Text>;
      },
    },
    {
      Header: "Situação",
      accessor: "situacao",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      Cell: (props) => {
        const riscoVida = props?.row?.original?.riscoVida;

        if (
          riscoVida === "S" &&
          !(
            roleKeycloack.includes(criancaFunc.visualizarTudo) ||
            roleKeycloack.includes(
              servicoAcolhimentoFunc.visualizarPartePPCAAM
            ) ||
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
            ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
              roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
              user?.orgaoExterno?.includes(
                props?.row?.original?.idPessoaJuridica
              ))
          )
        ) {
          return <Text></Text>;
        } else {
          return (
            <Text whiteSpace={"nowrap"}>{props.value ? props?.value : ""}</Text>
          );
        }
      },
    },
  ];

  const columnsComunitaria = [
    {
      Header: "Vínculo",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"}>
            {
              props?.value.pessoaFisicaReferenciaFamiliarComunitaria
                .tipoReferenciaFamiliar.descricao
            }
          </Text>
        );
      },
      sortType: (rowA, rowB) => {
        const descricaoA =
          rowA.original.pessoaFisicaReferenciaFamiliarComunitaria
            .tipoReferenciaFamiliar.descricao;
        const descricaoB =
          rowB.original.pessoaFisicaReferenciaFamiliarComunitaria
            .tipoReferenciaFamiliar.descricao;
        return descricaoA.localeCompare(descricaoB, undefined, {
          sensitivity: "base",
        });
      },
    },
    {
      Header: "Nome",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const nome =
          props?.value?.pessoaFisicaReferenciaFamiliarComunitaria?.nome;
        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={nome.length > 45 && "break-all"}
            title={nome}
          >
            {nome}
          </Text>
        );
      },
    },

    {
      Header: "CPF",
      accessor: (row) => {
        return (
          <Text whiteSpace={"nowrap"}>
            {row.pessoaFisicaReferenciaFamiliarComunitaria.cpf &&
              cpf(row.pessoaFisicaReferenciaFamiliarComunitaria.cpf)}
          </Text>
        );
      },
      sortType: "basic",
    },
    {
      Header: "Endereço",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const endereco = props.value.pessoaFisicaReferenciaFamiliarComunitaria;

        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={"break-all"}
          >
            {generateAddressFiliacao(endereco)}
          </Text>
        );
      },
      sortType: (rowA, rowB) => {
        const addressA =
          rowA.original.pessoaFisicaReferenciaFamiliarComunitaria;
        const addressB =
          rowB.original.pessoaFisicaReferenciaFamiliarComunitaria;

        const addressStringA = `${addressA.logradouro}, ${addressA.numeroResidencia}, ${addressA.bairro?.nome}, ${addressA.estado?.nome}-${addressA.estado?.sigla}`;
        const addressStringB = `${addressB.logradouro}, ${addressB.numeroResidencia}, ${addressB.bairro?.nome}, ${addressB.estado?.nome}-${addressB.estado?.sigla}`;

        return addressStringA.localeCompare(addressStringB, undefined, {
          sensitivity: "base",
        });
      },
    },
  ];

  const columnsGuarda = [
    {
      Header: "Tipo",
      accessor: "tipoTermoGuarda",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value.descricao}</Text>;
      },
      disableSortBy: true,
    },
    {
      Header: "Nome",
      accessor: "pessoaGuarda",
      Cell: (props) => {
        const nome = props?.value?.nome;

        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={"break-all"}
          >
            {nome}
          </Text>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
      disableSortBy: true,
    },
    {
      Header: "Decisão Judicial",
      accessor: "possuiGuarda",
      Cell: (props) => {
        return (
          <span>
            {props.value ? (
              <>
                <Flex marginLeft={10}>
                  <button onClick={() => getDownloadGuarda(id)}>
                    <IconeDownload />
                  </button>
                </Flex>
              </>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
  ];

  const fetchReferenciaData = useCallback(() => {
    setLoadingReferencia(true);
    CriancaService.getReferencia(id)
      .then((res) => {
        const sortedData = res.data.sort((a, b) =>
          a.pessoaFisicaReferenciaFamiliarComunitaria.tipoReferenciaFamiliar.descricao.localeCompare(
            b.pessoaFisicaReferenciaFamiliarComunitaria.tipoReferenciaFamiliar
              .descricao,
            undefined,
            { sensitivity: "base" }
          )
        );

        setData(sortedData);
        setLoadingReferencia(false);
        setLoadingPainel(true);
      })
      .catch((error) => {
        console.log("Error no getReferencia", error);
        setLoadingReferencia(false);
        setLoadingPainel(true);
      });
  }, [id, setLoadingPainel]);

  const fetchIrmaosData = useCallback(() => {
    setLoadingIrmaos(true);
    CriancaService.getIrmaos(id)
      .then((res) => {
        setDataIrmaos(res.data);
        const arrayDataNascimento = res?.data.map(
          (item) =>
            item?.pessoaFisicaIrmao?.dataNascimento &&
            intervalToDuration({
              start: new Date(item?.pessoaFisicaIrmao?.dataNascimento),
              end: new Date(),
            }).years
        );

        setMaiorIdade(
          arrayDataNascimento.map((item) => item >= 18).includes(true)
        );

        setLoadingIrmaos(false);
      })
      .catch((error) => {
        console.log("Error no getReferencia", error);
        setLoadingIrmaos(false);
      });
  }, [id]);

  const fetchDataGuarda = useCallback(() => {
    setLoadingGuarda(true);
    CriancaService.getGuardaReferenciaFamiliar(id)
      .then((res) => {
        setDataGuarda([res.data]);
        setLoadingGuarda(false);
      })
      .catch((error) => {
        setDataGuarda(null);
        console.log("Error no getReferencia", error);
        setLoadingGuarda(false);
      });
  }, [id]);

  const deleteReferencia = (idRelacionamento, onClose) => {
    Swal.fire({
      title: "Atenção!",
      text: "Ao excluir, as informações sobre a Referência Familiar serão excluídas. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteReferencia(id, idRelacionamento)
          .then((res) => {
            fetchReferenciaData();
            setLoadingPainel(true);
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {
              if (result.isConfirmed) {
                onClose();
              }
            });
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  const deleteIrmaos = (idCrianca, onClose, idPessoaFisicaIrmao) => {
    Swal.fire({
      title: "Atenção",
      text: "Ao excluir, as informações sobre o irmão serão excluídas. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteIrmaos(idCrianca, idPessoaFisicaIrmao)
          .then((res) => {
            fetchIrmaosData();
            setLoadingPainel(true);
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {
              if (result.isConfirmed) {
                onClose();
              }
            });
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  const deleteGuarda = (idGuarda, onClose) => {
    CriancaService.deleteGuardaReferenciaFamiliar(id, idGuarda)
      .then((res) => {
        fetchDataGuarda();
        setLoadingPainel(true);
        deleteUrlParam("idAnexo", history);
        Swal.fire({
          title: "Sucesso!",
          text: "Registro Excluído.",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#169499",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
          }
        });
      })
      .catch((error) => {
        console.log(error.response.data);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message ? error.response.data.message : "",
          icon: "error",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        });
      });
  };

  useEffect(() => {
    fetchReferenciaData();
    fetchDataGuarda();
    fetchIrmaosData();
  }, [fetchReferenciaData, fetchDataGuarda, fetchIrmaosData]);

  return roleKeycloack &&
    (roleKeycloack.includes(referenciaFunc.referenciaVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    <>
      <Group title="IRMÃOS" minHeight={"118px"}>
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, md: 5 }}
          spacing="20px"
          marginTop={{ base: "10px", md: "-50px" }}
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={referenciaFunc.irmaoIncluir}
            id={idPJ}
            user={user}
            visualizar={true}
          >
            <CustomButton
              label="Cadastrar"
              onClick={() => {
                onOpenCadastrar();
              }}
              isDisabled={isButtonDisabledSemFalecido}
              buttonBlocked={true}
            />
          </Permission>
          <IrmaosCadastrar
            isOpen={isOpenCadastrar}
            onOpen={onOpenCadastrar}
            setLoadingPainel={setLoadingPainel}
            idCrianca={id}
            onClose={() => {
              onCloseCadastrar();
            }}
            dataIrmaos={dataIrmaos}
            fetchIrmaosData={fetchIrmaosData}
          />
        </SimpleGrid>
        {!loadingIrmaos ? (
          <>
            {dataIrmaos && dataIrmaos.length > 0 ? (
              <Box
                mt={
                  roleKeycloack?.includes(referenciaFunc?.irmaoIncluir) ? 4 : 16
                }
              >
                <IrmaoTable
                  irmaos={true}
                  columns={columns}
                  entidade="irmaos"
                  data={dataIrmaos}
                  filiacoes={dataIrmaos}
                  idCrianca={id}
                  deleteIrmaos={deleteIrmaos}
                  fetchIrmaosData={fetchIrmaosData}
                  dataIrmaos={dataIrmaos}
                  isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                  onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                  onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                  idPJ={idPJ}
                />
              </Box>
            ) : (
              <Box
                mt={
                  roleKeycloack?.includes(referenciaFunc?.irmaoIncluir) ? 4 : 16
                }
              >
                <SemRegistros half buttonVisible={true} />
              </Box>
            )}
          </>
        ) : (
          <Box mt="2">
            <LoadingSpinner />
          </Box>
        )}
      </Group>
      <Group
        border={idTipoPendencia === "32" ? "3px solid #4299E199" : ""}
        title="REFERÊNCIA FAMILIAR E COMUNITÁRIA"
        minHeight={"118px"}
        scrollToField={
          idTipoPendencia === "32" && !loadingIrmaos && !loadingReferencia
            ? scrollToField
            : null
        }
      >
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, md: 5 }}
          spacing="20px"
          marginTop={{ base: "10px", md: "-50px" }}
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={referenciaFunc.referenciaIncluir}
            user={user}
            id={idPJ}
            visualizar={true}
          >
            <CustomButton
              width={"100%"}
              label="Cadastrar"
              onClick={() => {
                onOpenCadastrarReferencia();
                setCpfBlocked(false);
              }}
            />
          </Permission>
          <ComunitariaModal
            isOpen={isOpenCadastrarReferencia}
            onOpen={onOpenCadastrarReferencia}
            setLoadingPainel={setLoadingPainel}
            idCrianca={id}
            cpfBlocked={cpfBlocked}
            setCpfBlocked={setCpfBlocked}
            onClose={() => {
              onCloseCadastrarReferencia();
            }}
            fetchReferenciaData={fetchReferenciaData}
            dataReferencia={data}
          />
        </SimpleGrid>
        {!loadingReferencia ? (
          <>
            {data && data.length > 0 ? (
              <Box
                mt={
                  roleKeycloack.includes(referenciaFunc.referenciaIncluir)
                    ? 4
                    : 10
                }
              >
                <IrmaoTable
                  columns={columnsComunitaria}
                  data={data}
                  filiacoes={data}
                  entidade="referencia-comunitaria"
                  comunitaria={true}
                  deleteReferencia={deleteReferencia}
                  idCrianca={id}
                  fetchReferenciaData={fetchReferenciaData}
                  fetchDataGuarda={fetchDataGuarda}
                  cpfBlocked={cpfBlocked}
                  setCpfBlocked={setCpfBlocked}
                  dataReferencia={data}
                  idPJ={idPJ}
                />
              </Box>
            ) : (
              <Box
                mt={
                  roleKeycloack.includes(referenciaFunc.referenciaIncluir)
                    ? 4
                    : 16
                }
              >
                <SemRegistros half buttonVisible={true} />
              </Box>
            )}
          </>
        ) : (
          <Box mt="2">
            <LoadingSpinner />
          </Box>
        )}
      </Group>
      <Group
        title="GUARDA"
        minHeight={"118px"}
        border={idAnexo === "23" ? "3px solid #4299E199" : ""}
        scrollToField={
          idAnexo === "23" && !loadingIrmaos && !loadingReferencia
            ? scrollToField
            : null
        }
      >
        <>
          <SimpleGrid
            mt="30px"
            columns={{ base: 1, md: 5 }}
            spacing="20px"
            marginTop={{ base: "10px", md: "-50px" }}
            dir="rtl"
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={referenciaFunc.guardaIncluir}
              user={user}
              id={idPJ}
              visualizar={true}
            >
              <CustomButton
                width={"100%"}
                label="Cadastrar"
                isDisabled={
                  ((data && data.length <= 0) ||
                    (dataGuarda && dataGuarda.length > 0)) &&
                  isButtonDisabledFiliacao &&
                  ((dataIrmaos && dataIrmaos.length <= 0) || !maiorIdade)
                }
                buttonBlocked={true}
                onClick={() => {
                  onOpenCadastrarGuarda();
                }}
              />
            </Permission>
            <GuardaModal
              isOpen={isOpenCadastrarGuarda}
              onOpen={onOpenCadastrarGuarda}
              roleKeycloack={roleKeycloack}
              idCrianca={id}
              onClose={() => {
                onCloseCadastrarGuarda();
              }}
              fetchDataGuarda={fetchDataGuarda}
            />
          </SimpleGrid>

          {dataGuarda && dataGuarda.length > 0 ? (
            <Box
              mt={roleKeycloack.includes(referenciaFunc.guardaIncluir) ? 4 : 20}
            >
              <IrmaoTable
                roleKeycloack={roleKeycloack}
                columns={columnsGuarda}
                data={dataGuarda}
                filiacoes={dataGuarda}
                entidade="guarda"
                guarda={true}
                deleteGuarda={deleteGuarda}
                fetchDataGuarda={fetchDataGuarda}
                idCrianca={id}
                idPJ={idPJ}
              />
            </Box>
          ) : (
            <Box
              mt={roleKeycloack.includes(referenciaFunc.guardaIncluir) ? 4 : 20}
            >
              <SemRegistros half buttonVisible={true} />
            </Box>
          )}
        </>
      </Group>
    </>
  ) : (
    <Box mt={4}>
      <SemRegistros half buttonVisible={true} />
    </Box>
  );
};
